// extracted by mini-css-extract-plugin
export default {"postContainer":"PostContainer-module--postContainer--dcd6f","postContainer__wrapper":"PostContainer-module--postContainer__wrapper--de6a9"};